import React, { FC } from 'react'
import { LocalizationProvider, AdapterMoment } from 'transfix-ui/core/pickers'

export const DatePickersProvider: FC = ({ children }) => {
  return <LocalizationProvider dateAdapter={AdapterMoment}>{children}</LocalizationProvider>
}
